<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <caso-sidebar v-if="addNewDataSidebar" :propModeView="sidebarViewMode" :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar" @refresh="updateTable" :data="sidebarData" :modeCreateProp="modeCreate" />

    <vs-table ref="table" :sst="true" :max-items="itemsPerPage" search :total="queriedItems" @search="handleSearch" noDataText="No hay datos disponibles" :data="casos">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Crear caso</span>
          </div>
          <vs-button icon-pack="feather" icon="icon-download" :disabled="this.lista_lb_tmp_excel.length === 0"
            class="p-3 mb-4 mr-4" @click="downloadExcel()"></vs-button>
        </div>

        <div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <!-- bg-primary text-white -->
              <span class="mr-2">Estados de caso</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="changeCaseStates('Abiertos')">
                <span v-if="caseStates === 'Abiertos'" style="color:forestgreen">Casos abiertos</span>
                <span v-else>Casos abiertos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changeCaseStates('Cerrados')">
                <span v-if="caseStates === 'Cerrados'" style="color:forestgreen">Casos cerrados</span>
                <span v-else>Casos cerrados</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  queriedItems - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : queriedItems
                }}
                de {{ queriedItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="updateItemsPerPage(4)">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updateItemsPerPage(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updateItemsPerPage(15)">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updateItemsPerPage(20)">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th :key="indexth" v-for="(row, indexth) in meta" :sort-key="row.sortKey" v-if="row">
          <p class="product-name font-medium truncate">{{ row.title }}</p>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :state="tr.estado == 1 ? 'success' : null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"
            v-if="tr" @click.native="displayData(tr)">
            <!-- <wb-button @click="displayData(tr)"> -->
              <!-- <div @click="displayData(tr)"> -->
            <vs-td>
              <p class="product-name font-medium truncate text-danger" v-if="tr.colorAdvance === 'rojo'">
                {{ tr.id }}
              </p>
              <p class="product-name font-medium truncate text-yellow" v-else-if="tr.colorAdvance === 'amarillo'">
                {{ tr.id }}
              </p>
              <p class="product-name font-medium truncate" v-else>
                {{ tr.id }}
              </p>

            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.descripcion }}</p>
            </vs-td>
            <!-- <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.compañia.descripcion }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.proyecto.descripcion }}</p>
            </vs-td> -->

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.proyecto.descripcion }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.subproyecto && tr.subproyecto.descripcion ? tr.subproyecto.descripcion : '-' }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.tipoActividad.descripcion }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.fechaRegistro }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.fechaRealFin }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate text-danger" v-if="tr.colorAdvance === 'rojo'">
                {{ tr.descRequestStatus }}
              </p>
              <p class="product-name font-medium truncate text-success" v-else-if="tr.colorAdvance === 'verde'">
                {{ tr.descRequestStatus }}
              </p>
              <p class="product-name font-medium truncate" v-else>
                {{ tr.descRequestStatus }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.area ? tr.area.descripcion : '' }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.nameUser }}
              </p>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-dark stroke-current"
                @click.stop="displayData(tr)" />
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                @click.stop="editData(tr)" v-if="company === 1" />
              <feather-icon icon="PlayIcon" svgClasses="w-5 h-5 hover:text-success stroke-current" class="ml-2"
                @click="activePromptM(1, tr)" v-if="tr.estado != 1 && (caseStates === 'Abiertos' || caseStates === 'Filtro')" />
              <feather-icon icon="PauseIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current" class="ml-2"
                @click="activePromptM(2, tr)" v-if="tr.estado == 1 && (caseStates === 'Abiertos' || caseStates === 'Filtro')" />
              <feather-icon icon="SquareIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click="activePromptM(3, tr)" v-if="(tr.estado >= 1 && tr.estado != 8) && (caseStates === 'Abiertos' || caseStates === 'Filtro')" />
              <!-- <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.IDLICITACION)"
              /> -->

              <!-- <vs-dropdown :color="colorx">
                <a class="a-icon" href="#">
                  Opciones
                  <vs-icon class="" icon="expand_more"></vs-icon>
                </a>

                <vs-dropdown-menu>
                  <vs-dropdown-item @click.stop="displayData(tr)">
                    <div>
                      <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-dark stroke-current" />
                      Ver caso
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item divider v-if="tr.estado != 1 && caseStates === 'Abiertos'"
                    @click="activePromptM(1, tr)">
                    <div>
                      <feather-icon icon="PlayIcon" svgClasses="w-5 h-5 hover:text-success stroke-current"
                        class="ml-2" /> Procesar
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item divider v-if="tr.estado == 1 && caseStates === 'Abiertos'"
                    @click="activePromptM(2, tr)">
                    <div>
                      <feather-icon icon="PauseIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current"
                        class="ml-2" />
                      Pausar
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item divider v-if="(tr.estado >= 1 && tr.estado <= 7) && caseStates === 'Abiertos'"
                    @click="activePromptM(3, tr)">
                    <div>
                      <feather-icon icon="SquareIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="ml-2" />
                      Cerrar
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
            </vs-td>
          <!-- </div> -->
          <!-- </wb-button> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination class="mt-3" :total="Math.round(queriedItems / itemsPerPage)" v-model="pageSelected" @change="handleChangePage"></vs-pagination>

    <vs-prompt :color="activePromptOption === 1 ? 'success' : activePromptOption === 2 ? 'warning' : 'danger'"
      @cancel="valMultipe.value1 = '', valMultipe.value2 = 'Y'" @accept="acceptAlert" @close="close"
      :title="activePromptOption === 1 ? 'Procesar caso' : activePromptOption === 2 ? 'Pausar caso' : 'Cerrar caso'"
      acceptText="Aceptar" cancelText="Cancelar" :is-valid="validObservation" :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <p>Ingresa la observación para <b>continuar</b>.</p>
        <vs-textarea class="my-6 w-full" placeholder="Observación" v-model="valMultipe.value1" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import CasoSidebar from '@/views/caso/CasoSidebar.vue'
import CasoModule from '@/store/caso-module/moduleDataList.js'
import XLSX from 'xlsx'
import { searchCompany } from '../../config/companies';

export default {
  components: {
    CasoSidebar
  },
  created () {
    this.company = searchCompany(this.$route.params.nameCompany).idCompany
    // Loading
    if (!CasoModule.isRegistered) {
      this.$store.registerModule('CasoModule', CasoModule)
      CasoModule.isRegistered = true
    }
    this.updateTable()

    //console.log('usuario', this.$store.state.auth.userDetails())
  },
  mounted () {
    this.isMounted = true
  },
  data () {
    return {
      selected: [],
      pageSelected: 1,
      itemsPerPage: 10,
      isMounted: false,
      indexDelete: '',
      caseStates: 'Abiertos',
      filterData: '',
      casoData: {},
      company: -1,

      activePrompt: false,
      valMultipe: {
        value1: '',
        value2: 'Y'
      },
      activePromptOption: 0,
      infoConfirmText: '',

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarViewMode: true,
      modeCreate: true,
      colorx: '#c80948',
      lista_lb_tmp_excel: []
    }
  },
  computed: {
    currentPage () {
      /*if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0*/
      return this.pageSelected
    },
    casos () {
      return this.$store.state.CasoModule.casos
    },
    meta () {
      return this.$store.state.CasoModule.meta
    },
    queriedItems () {
      return this.$store.state.CasoModule.total_casos

      /*this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.casos.length*/
    },
    validObservation () {
      return (this.valMultipe.value1 && this.valMultipe.value1.length > 0)
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
      this.modeCreate = true
    },
    /*deleteData (licitacionId) {
      this.indexDelete = licitacionId
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la contratación "${licitacionId}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    deleteRecord () {
      const idLicitacionTmp = this.indexDelete
      this.$store
        .dispatch('CasoModule/getLicitacionProponentes', idLicitacionTmp)
        .then((response) => {
          console.log('Respuesta de remover:', response.data)
          if (response.data.nuOK === 0) {
            this.$vs.notify({
              color: 'success',
              title: 'Caso eliminado',
              text: `El caso ha sido eliminada del sistema.`
            })
            this.updateTable()
          }
        })
        .catch((ex) => {
          if (ex.data.errorDesc !== null && ex.data.errorDesc !== undefined) {
            this.$vs.notify({
              color: 'warning',
              title: 'Caso no eliminado',
              text: ex.data.errorDesc
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error al actualizar datos',
              text: 'No es posible actualizar en la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },*/
    displayData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = true
      this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
      this.modeCreate = false
    },
    activePromptM (option, caso) {
      console.log('activePromptM caso, ', caso)

      const idUser = this.$store.state.auth.userDetails().id
      this.casoData = caso

      console.log(`usuario 1, ${idUser}`)
      console.log(`usuario 2, ${caso.usuario}`)

      if (caso.usuario === idUser) {
        this.activePrompt = true
        this.activePromptOption = option
      } else {
        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text:
            'El usuario no tiene asignado el caso para realizar esta acción.',
          acceptText: 'Aceptar'
        })
      }
    },
    downloadExcel () {
      // console.log(JSON.stringify(this.lista_lb_tmp_excel))

      if (this.lista_lb_tmp_excel.length > 0) {
        const data = XLSX.utils.json_to_sheet(this.lista_lb_tmp_excel)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        XLSX.writeFile(wb, 'reporte.xlsx')

      } else {
        this.$vs.dialog({
          color: 'warning',
          title: 'Aviso',
          text:
            'No hay datos para descargar.',
          acceptText: 'Aceptar'
        })
      }
    },
    acceptAlert () {
      this.activePrompt = false

      const dataTmp = {
        idRequest: this.casoData.id,
        idUser: this.$store.state.auth.userDetails().id,
        observation: this.valMultipe.value1
      }

      this.$vs.loading()
      // Procesar caso
      if (this.activePromptOption === 1) {
        this.$store
          .dispatch('CasoModule/procesarCaso', dataTmp)
          .then((response) => {
            this.$vs.loading.close()
            if (response) {

              this.$vs.dialog({
                color: 'success',
                title: 'Aviso',
                text:
                  'El caso se procesó con éxito.',
                acceptText: 'Aceptar'
              })

              this.changeCaseStates('Abiertos')
            } else {
              this.$vs.dialog({
                color: 'danger',
                title: 'Error',
                text:
                  'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
                acceptText: 'Aceptar'
              })
            }
          })
          .catch((response) => {
            console.log('getCasoById response error,', response)
            this.$vs.loading.close()

            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          })
      }
      // Pausar caso
      if (this.activePromptOption === 2) {
        this.$store
          .dispatch('CasoModule/pausarCasoByUser', dataTmp)
          .then((response) => {
            this.$vs.loading.close()
            if (response) {

              this.$vs.dialog({
                color: 'success',
                title: 'Aviso',
                text:
                  'El caso se pausó con éxito.',
                acceptText: 'Aceptar'
              })

              this.changeCaseStates('Abiertos')
            } else {
              this.$vs.dialog({
                color: 'danger',
                title: 'Error',
                text:
                  'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
                acceptText: 'Aceptar'
              })
            }
          })
          .catch((response) => {
            console.log('getCasoById response error,', response)
            this.$vs.loading.close()

            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          })
      }
      // Cerrar caso
      if (this.activePromptOption === 3) {
        this.$store
          .dispatch('CasoModule/cerrarCasoByUser', dataTmp)
          .then((response) => {
            this.$vs.loading.close()
            if (response) {

              this.$vs.dialog({
                color: 'success',
                title: 'Aviso',
                text:
                  'El caso se cerró con éxito.',
                acceptText: 'Aceptar'
              })

              this.changeCaseStates('Abiertos')
            } else {
              this.$vs.dialog({
                color: 'danger',
                title: 'Error',
                text:
                  'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
                acceptText: 'Aceptar'
              })
            }
          })
          .catch((response) => {
            console.log('getCasoById response error,', response)
            this.$vs.loading.close()

            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          })
      }

      this.valMultipe = {
        value1: '',
        value2: 'Y'
      }
    },
    close () {
      this.activePrompt = false
      this.valMultipe = {
        value1: '',
        value2: 'Y'
      }
    },
    displayView (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    changeCaseStates (state) {
      this.caseStates = state

      /*if (state === 'Cerrados') {
        this.getAllCasosCerrados()
      } else {*/
      this.updateTable()
      //}
    },
    getOrderStatusColor (status) {
      if (status === 'on_hold') return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled') return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    updateTable () {
      this.$vs.loading()
      this.$store
        .dispatch('CasoModule/getAllCasosByStatePag',
          {
            id: this.$store.state.auth.userDetails().id,
            state: this.caseStates,
            filter: this.filterData,
            pageNumber: this.pageSelected,
            pageSize: this.itemsPerPage
          })
        .then((response) => {
          this.$vs.loading.close()
          //console.log('Casos response: ', response.data.lista)
          this.updateListaCasosExcel(response.data.lista)
        })
        .catch(() => {
          this.$vs.loading.close()

          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text:
              'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
            acceptText: 'Aceptar'
          })
        })
    },
    updateItemsPerPage (itemsPerPage) {
      this.itemsPerPage = itemsPerPage

      this.updateTable()
    },
    handleChangePage (item) {
      this.pageSelected = item

      this.updateTable()
    },
    handleSearch (text) {
      console.log('handleSearch', text)

      if (text.length >= 5) {
        this.caseStates = 'Filtro'
        this.filterData = text
        this.pageSelected = 1
        this.itemsPerPage = 10

        this.updateTable()
      } else if (text.length === 0) {
        this.pageSelected = 1
        this.itemsPerPage = 10
        this.caseStates = 'Abiertos'

        this.updateTable()
      }
    },
    /*getAllCasosCerrados () {
      this.$vs.loading()
      this.$store
        .dispatch('CasoModule/getAllCasosCerrados', { id: this.$store.state.auth.userDetails().id })
        .then((response) => {
          this.$vs.loading.close()
          //console.log('Casos cerrados response: ', response.data.lista)
          this.updateListaCasosExcel(response.data.lista)
        })
        .catch(() => {
          this.$vs.loading.close()

          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text:
              'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
            acceptText: 'Aceptar'
          })
        })
    },*/
    updateListaCasosExcel (lista) {
      //console.log('Casos updateListaCasosExcel: ', lista)

      this.lista_lb_tmp_excel = []
      lista.forEach(element => {

        const tmp_excel = {
          CODIGO: element.id,
          DESCRIPCION: element.descripcion,
          PROYECTO: element.proyecto ? element.proyecto.descripcion : '',
          SUBPROYECTO: element.subproyecto ? element.subproyecto.descripcion : '',
          TIPO_CASO: element.tipoActividad ? element.tipoActividad.descripcion : '',
          FECHA_COMPROMISO: element.fechaRegistro,
          FECHA_FINALIZACION : element.fechaRealFin,
          ESTADO: element.descRequestStatus,
          AREA: element.area ? element.area.descripcion : '',
          USUARIO: element.nameUser
        }

        this.lista_lb_tmp_excel.push(tmp_excel)
      })
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
